var _ = require("lodash");
var { UntypedArrayId } = require("../typing/typing");

var SumForm = require("./Forms").SumForm;

/**
 * form transformation that flattens SumForm.
 * @memberof flattenTrans
 * @param {Form} form
 * @return {Object} a pair of flat form and
 *   variant map converting
 *   a variant of new form to one of the old form
 * @memberof module:Forms
 */
function flattenTrans(form) {
  switch(form.type) {
    case "SumForm":
      // an array of { form, map }, where form is an array
      var fs = UntypedArrayId(form.subforms)
        .map(flattenTrans)
        .map(function(fm) {
            if(fm.form.type == "SumForm") {
              if(fm.form.caption === undefined) {
                return { form: UntypedArrayId(fm.form.subforms), map: fm.map };
              } else {
                return {
                  form: [ fm.form ],
                  map: function(v){ return fm.map(v.value); }
                };
              }
            } else
              return { form: [ fm.form ], map: function(v){ return v.value; } };
          });
      // an array of subarrays
      var ls = fs.map(function(fm) { return fm.form.length; });
      // concatenated array of subforms
      var cs = _.flatten(fs.map(function(fm) { return fm.form; }));
      return {
        form: new SumForm(cs, form.caption),
        map: function(v) {
          // assert v.mark < cs.length
          // i is an index a sum of lengths of first f arrays
          for(var i = 0, f = 0; v.mark >= i + ls[f]; ++f) {
            // assert f < ls.length
            i += ls[f];
          }
          return {
            mark: f,
            value: fs[f].map({ mark: v.mark - i, value: v.value })
          };
        }
      };
  }
  // for other cases a transformation is identity
  return { form: form, map: _.identity };
}

module.exports = flattenTrans;
